/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentitySettingsListItem,
    IdentitySettingsListItemFromJSON,
    IdentitySettingsListItemFromJSONTyped,
    IdentitySettingsListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentitySettingsListItemPaginationWrapper
 */
export interface IdentitySettingsListItemPaginationWrapper {
    /**
     * 
     * @type {Array<IdentitySettingsListItem>}
     * @memberof IdentitySettingsListItemPaginationWrapper
     */
    items?: Array<IdentitySettingsListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentitySettingsListItemPaginationWrapper
     */
    totalItems?: number;
}

export function IdentitySettingsListItemPaginationWrapperFromJSON(json: any): IdentitySettingsListItemPaginationWrapper {
    return IdentitySettingsListItemPaginationWrapperFromJSONTyped(json, false);
}

export function IdentitySettingsListItemPaginationWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentitySettingsListItemPaginationWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(IdentitySettingsListItemFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
    };
}

export function IdentitySettingsListItemPaginationWrapperToJSON(value?: IdentitySettingsListItemPaginationWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(IdentitySettingsListItemToJSON)),
        'totalItems': value.totalItems,
    };
}


